module.exports = __webpack_public_path__ + "static/img/NSW-23.a388163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-23.jpg
// module id = onI3
// module chunks = 0